import * as React from "react";
function SvgArrowsStretching(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M3 18v11h10M29 14V3H18M29 3L3 29" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowsStretching);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
